import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import SortDropdown from './SortDropdown';
import ViewToggle from './ViewToggle';
import { useTranslation } from 'react-i18next';

const ProductListHeader = ({ 
  totalProducts, 
  currentSort, 
  onSortChange, 
  viewMode, 
  onViewModeChange, 
  onOpenFilters,
  searchQuery,
  selectedCategory,
  loading 
}) => {
  const { t } = useTranslation();

  const formatProductCount = (count) => {
    return count;
  };

  const getHeaderTitle = () => {
    if (searchQuery) {
      return `${t('searchResultsFor')} "${searchQuery}"`;
    }
    if (selectedCategory) {
      const categoryLabels = {
        'electronics': t('electronics'),
        'clothing': t('clothing'),
        'home': t('home'),
        'beauty': t('beauty'),
        'sports': t('sports'),
        'books': t('books'),
        'toys': t('toys'),
        'automotive': t('automotive')
      };
      return categoryLabels[selectedCategory] || t('products');
    }
    return t('allProducts');
  };

  const getHeaderSubtitle = () => {
    if (loading) {
      return t('loadingProducts');
    }
    if (totalProducts === 0) {
      return t('noProductsFound');
    }
    if (totalProducts === 1) {
      return t('oneProductFound');
    }
    return `${formatProductCount(totalProducts)} ${t('productsFound')}`;
  };

  return (
    <div className="bg-surface border-b border-border">
      <div className="px-4 py-4">
        {/* Header Title */}
        <div className="mb-4">
          <h1 className="text-2xl font-semibold text-text-primary mb-1">
            {getHeaderTitle()}
          </h1>
          <p className="text-text-secondary">
            {getHeaderSubtitle()}
          </p>
        </div>

        {/* Controls */}
        <div className="flex items-center justify-between gap-4">
          {/* Left Side - Mobile Filter Button */}
          <div className="flex items-center space-x-3">
            <Button
              variant="outline"
              size="sm"
              onClick={onOpenFilters}
              iconName="Filter"
              iconPosition="left"
              className="lg:hidden"
            >
              {t('filters')}
            </Button>

        
          </div>

          {/* Right Side - Sort and View Controls */}
          <div className="flex items-center space-x-3">
            {/* View Toggle - Desktop Only */}
            <div className="hidden md:block">
              <ViewToggle
                viewMode={viewMode}
                onViewModeChange={onViewModeChange}
              />
            </div>

            {/* Sort Dropdown */}
            <SortDropdown
              currentSort={currentSort}
              onSortChange={onSortChange}
            />
          </div>
        </div>

        {/* Mobile View Toggle */}
        <div className="md:hidden mt-3 flex justify-center">
          <ViewToggle
            viewMode={viewMode}
            onViewModeChange={onViewModeChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductListHeader;
